import { createFileRoute } from "@tanstack/react-router";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { StaffScreen } from "../components/settings/staff-screen.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/personal")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <StaffScreen franchiseId={franchise.id} />;
}
